
import axios from 'axios'
import { apiUrls } from './api';
export class PaymentService {
  constructor () {
    this.paymentUrl = apiUrls.chargeCustomer;
    this.verificationUrl = apiUrls.purchaseExists;
    this.resendPurchaseUrl = apiUrls.resendEmail;
    this.totalNumPurchasesUrl = apiUrls.totalNumPurchases;
    this.currentItem = 'SOLID_BOOK_PREORDER';
  }

  async resendPurchaseEmail (email) {
    await axios({
      method: 'POST',
      url: `${this.resendPurchaseUrl}`,
      data: {
        email
      }
    });
  }

  async getTotalNumberPurchases () {
    const response = await axios({
      method: 'GET',
      url: `${this.totalNumPurchasesUrl}`
    });
    return response.data.numPurchases;
  }

  async checkPaid (hash) {
    try {
      await axios({
        method: 'GET',
        url: `${this.verificationUrl}?hash=${hash}`
      });
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }

  makePayment (email, token, name, method) {
    return axios({
      method: 'POST',
      url: this.paymentUrl,
      data: {
        email: email,
        token: token,
        name: name,
        method: method ? method : '',
        item: this.currentItem
      }
    })
  }
}